import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { DOCUMENT_PERMISSION_ROLE_PREFIX_URL } from './constants/config.document-permission-role'

const ListPage = lazy(() => import('./pages/ListPage.DocumentPermissionRole'))

const DocumentPermissionRoleRouters: AppRouterItem[] = [
  {
    path: `${DOCUMENT_PERMISSION_ROLE_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPage />
      </LoadingLazyComponents>
    ),
  },
]

export default DocumentPermissionRoleRouters
